import { Component, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT, Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'Tocars Brokers';
  

  constructor(private location: Location, private router: Router,  private _renderer2: Renderer2, @Inject(DOCUMENT) private _document: Document) {
 
  }
}
